import React from 'react';
import './index.scss';
import {connect} from 'react-redux';
import {bindActionCreators, Dispatch} from 'redux';
import {ApplicationState} from '../../store';
import {User, UserTypes} from '../../store/ducks/user/types';
import * as UserActions from '../../store/ducks/user/actions';
import {Param, ParamTypes} from '../../store/ducks/param/types';
import {Cart, CartTypes, ProductType} from '../../store/ducks/cart/types';
import * as CartActions from '../../store/ducks/cart/actions';
import * as ParamActions from '../../store/ducks/param/actions';
import { Redirect, Link } from "react-router-dom";
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import UserSidebar from '../../components/UserSidebar';

import Api from '../../services/api';
import {Diversos} from '../../services/diversos';

import InputMask from "react-input-mask";

import Row from 'react-bootstrap/Row'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import {Spinner} from 'react-bootstrap'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faShoppingCart, faEdit, faTimes, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { findDOMNode } from 'react-dom';
import logoPreta from '../../assets/Images/domakoski-preta.jpg'

import produto from '../../assets/Images/image-1.png'


interface StateProps { 
  user: User;
  cart?: Cart;
  param: Param;
}

interface DispatchProps {
  doLogin(user: User): void;
  doLogout(): void;

  add(cart: ProductType): void;
  update(cart: ProductType): void;
  drop(rowid: string): void;
  setParam(data: Param): void;
}


interface OwnProps {
  item?: any;
}

type Props = StateProps & DispatchProps & OwnProps;

// function Favorito (props) {

//   return (
//     <div className="dados-container fav-container">
//       <a title="Remover dos favoritos"> <FontAwesomeIcon icon={faTimes}/> </a>
//       <span className="fav-product">
//         <img src={props.src}/>
//         <span>
//           <p> { props.produto } </p>
//           <p> { props.valor } </p>
//         </span>
//       </span>
//       <Button title="Adicionar ao carrinho" className="btn-primary-action"> Comprar <FontAwesomeIcon icon={faShoppingCart}/> </Button>
//     </div>
//   );
// }

class MeuCadastro extends React.Component<Props> {

  api: any = null;
  state: any = null;

  constructor(props) {
    super(props);

    this.api = new Api();

    this.state = {
      redirect: null,
      pswHidden: true,
      confHidden: true,
      currentStep: 1,
      pagamento: true,
      
      // VARIAVEIS DE CONTROLE PARA FORM DE CADASTRO JA EXISTENTE
      isLoadingCustomer: true,
      customer: null,
      customerHasError: false,
      customerHasErrorTitle: null,
      customerHasErrorMsg: null,
      customerHasSuccess: false,
      customerHasSuccessTitle: null,
      customerHasSuccessMsg: null,

      isLoadingCep: false
    }

    this.toggleShow = this.toggleShow.bind(this);
  }

  componentDidMount () {
    const self = this;

    if (( self.props.user ) && ( self.props.user.status !== false )) { 
      self.getCustomer();
    }
  }

  toggleShow(input: number) {
    if (input === 1) {
      this.setState({ pswHidden: !this.state.pswHidden });
      return;
    }

    this.setState({ confHidden: !this.state.confHidden });
  }

  private async handleLogout () {
    const self = this;
    self.props.doLogout();
    self.setState({redirect: "/"});
  }

  private async getCustomer () {
    const self = this;

   self.setState({isLoadingCustomer: true});

    try {
      const {data} = await self.api.get(`/customer/${self.props.user.codigo}`);

      if ( data.status == false ) {
        throw new Error('Cadastro de cliente não localizado.');
      } else {
        self.setState({customer: data.msg});
      }

    } catch (e) {
      console.error(e);

      self.setState({
        customer: null,
        customerHasError: true,
        customerHasErrorTitle: 'Cadastro não localizado',
        customerHasErrorMsg: e.message
      });

    } finally {
      self.setState({isLoadingCustomer: false});
    }
  }

  private async getAddressByCep () {
    const self = this;

    if ( !self.state.customer.cep )
      return false;

    self.setState({isLoadingCep: true});

    let param = {cep : self.state.customer.cep}

    try {
      const {data} = await self.api.post('/shipping/cep', param);

      if ( data.status ) {
        self.setState({customer: {
          ...self.state.customer,
          rua: data.msg.logradouro,
          bairro: data.msg.bairro,
          cidade: data.msg.localidade,
          estado: data.msg.uf
        }});
      }

    } catch (e) {
      console.error(`ERROR: /shipping/cep: ${e}}`);
    } finally {
      self.setState({isLoadingCep: false});
    }
  }

  /**
   * FUNCAO PARA TRATAR EDICAO DE CADASTRO
   */
  private async handleSubmit ( tab: number = 0 ) {
    const self = this;
    let link: string = `/customer/${self.props.user.codigo}`;
    let param: any = {};

    if ((tab < 1) || (tab > 3))
      return false;

    if ( tab === 1 ) {
      if (( !self.state.customer.email ) || ( !self.state.customer.nome ) || ( !self.state.customer.cpf ) || ( !self.state.customer.celular )) {
        self.setMsg( 'error', "Formulário incompleto", "Necessário preencher todos os campos obrigatórios (*) do formulário para continuar.", 1);
        return;
      }

      if ( !Diversos.validateCPF(self.state.customer.cpf) ) {
        self.setMsg( 'error', "CPF inválido", "Necessário informar um CPF válido para continuar.", 1);
        return;
      }

      if ( !Diversos.validateEmail(self.state.customer.email) ) {
        self.setMsg( 'error', "Email inválido", "Necessário informe um email válido para continuar.", 1);
        return;
      }

      param.nome = self.state.customer.nome;
      param.email = self.state.customer.email;
      param.cpf = self.state.customer.cpf;
      param.nascimento = self.state.customer.nascimento;
      param.sexo = self.state.customer.sexo;
      param.celular = self.state.customer.celular;
      param.telefone = self.state.customer.telefone;
    }

    if ( tab === 2 ) {
      if (( !self.state.customer.cep ) || ( !self.state.customer.rua ) || ( !self.state.customer.numero ) || ( !self.state.customer.bairro ) || ( !self.state.customer.cidade ) || ( !self.state.customer.estado )) {
        self.setMsg( 'error', "Formulário incompleto", "Necessário preencher todos os campos obrigatórios (*) do formulário para continuar.", 1);
        return;
      }

      param.cep = self.state.customer.cep;
      param.rua = self.state.customer.rua;
      param.numero = self.state.customer.numero;
      param.complemento = self.state.customer.complemento;
      param.bairro = self.state.customer.bairro;
      param.cidade = self.state.customer.cidade;
      param.estado = self.state.customer.estado;
    }

    if ( tab === 3 ) {
      if (( !self.state.senhaAtual ) || ( !self.state.senhaNova ) || ( !self.state.confSenhaNova )) {
        self.setMsg( 'error', "Formulário incompleto", "Necessário preencher todos os campos obrigatórios (*) do formulário para continuar.", 1);
        return;
      }

      if ( self.state.senhaNova !== self.state.confSenhaNova ) {
        self.setMsg( 'error', "Confirmação da senha inválida", "Senha nova e sua confirmação não são iguais.", 1);
        return;
      }

      param.senha = self.state.senhaAtual;
      param.senhaNova = self.state.senhaNova;
      link = `/customer/${self.props.user.codigo}/troca-senha`;
    }

    self.setState({ isLoading: true });

    try {
      const {data} = await self.api.put(link, param);

      if (!data.status) {
        throw new Error(data.msg);
      } else {
        self.setMsg( 'success', "Sucesso", `Cadastro atualizado com sucesso.`, 1);
      }

    } catch (e) {
      console.error(e);
      self.setMsg( 'error', "Atenção", `Não foi possível atualizar cadastro. ${e.message}`, 1);
    } finally {
      self.setState({ isLoading: false });
    }
  }

  /**
   * FUNCAO PARA SETAR ALERT DE ERROR OU SUCESSO COM TEMPORIZADOR
   * @param type 
   * @param title 
   * @param msg 
   * @param form 
   */
  private async setMsg ( type: string, title: string, msg: string, form: number ) {
    const self = this;
    let timeout = 5000;

    if ( type === "error" ) {
      if ( form === 1 ) {
        self.setState({
          customerHasError: true,
          customerHasErrorTitle: title,
          customerHasErrorMsg: msg,
        }, () => {
          setTimeout(() => self.setState({ customerHasError: false }), timeout)
        });
      } else {
        self.setState({
          customerHasError: true,
          customerHasErrorTitle: title,
          customerHasErrorMsg: msg,
        }, () => {
          setTimeout(() => self.setState({ customerHasError: false }), timeout)
        });
      }
    } else {
      if ( form === 1 ) {
        self.setState({
          customerHasSuccess: true,
          customerHasSuccessTitle: title,
          customerHasSuccessMsg: msg,
        }, () => {
          setTimeout(() => self.setState({ customerHasSuccess: false }), timeout)
        });
      } else {
        self.setState({
          novoHasSuccess: true,
          novoHasSuccessTitle: title,
          novoHasSuccessMsg: msg,
        }, () => {
          setTimeout(() => self.setState({ novoHasSuccess: false }), timeout)
        });
      }
    }
  }

  handleAddCart (event) {
    const self = this;
    event.preventDefault();
    self.props.add({
      // codigo: self.props.item.CODIGO,
      // nome: self.props.item.NOME,
      // price: self.props.item.PRECO,
      codigo: 2,
      nome: "produto 1",
      price: 2,
      qty: 1
    });
    self.props.setParam({ ...self.props.param, cartOpened: true });
  }


  render () {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />
    }

    // const solidHeart = <i className="far fa-heart"/>

    return (
      <>
        <Header/>

        <section className="meu-cadastro-section">
          <Row className="mx-0 user-row">
            <Col lg={4} xl={3} className="user-meu-cadastro">
              <UserSidebar/>
            </Col>

            <Col lg={8} xl={9} className="meu-cadastro-form">
  
              <span id="meu-perfil"/>
              <h2> Meu Perfil </h2>
              {
              this.state.isLoadingCustomer === true ?
                <>
                  <span className="py-3 w-100 h-100 m-auto text-center d-flex justify-content-center">
                    <FontAwesomeIcon icon={faCircleNotch} spin={true} className="text-center m-auto spinner" style={{fontSize: 24}}/>
                  </span>
                </>
              :
              <>
                <span className="title-action">
                  <h3> Dados da conta </h3>
                  <a title="Clique para editar" href="/editar/perfil"> <FontAwesomeIcon icon={faEdit}/> </a>
                </span>

                <article className="dados-da-conta">
                  <div className="dados-container">
                    <p> E-mail: </p>
                    <p> { this.state.customer.email } </p>
                  </div>
                  <div className="dados-container">
                    <p> Senha: </p>
                    <p> ****** </p>
                  </div>
                </article>
                
                <span className="title-action">
                  <h3> Dados pessoais </h3>
                  <a title="Clique para editar" href="/editar/pessoal"> <FontAwesomeIcon icon={faEdit}/> </a>
                </span>

                <article className="dados-da-conta">
                  <div className="dados-container">
                    <p> Nome: </p>
                    <p> { this.state.customer.nome } </p>
                  </div>
                  <div className="dados-container">
                    <p> CPF: </p>
                    <p> { this.state.customer.cpf } </p>
                  </div>
                  <div className="dados-container">
                    <p> Data de Nascimento: </p>
                    <p> { this.state.customer.nascimento } </p>
                  </div>
                  <div className="dados-container">
                    <p> Sexo: </p>
                    <p> { this.state.customer.sexo } </p>
                  </div>
                  <div className="dados-container">
                    <p> Telefone 1: </p>
                    <p> { this.state.customer.celular } </p>
                  </div>
                  <div className="dados-container">
                    <p> Telefone 2: </p>
                    <p> { this.state.customer.telefone || "-" } </p>
                  </div>
                </article>

                <span id="reset-senha"/>
                <h3> Reset de Senha </h3>
                <a className="btn-link-action" href="/reset-senha"> Solicitar uma mudança de senha </a> 


                {/* <h3> Formas de Pagamento </h3>
                {
                  (this.state.pagamento) ?
                  "A"
                  :
                  <span className="register-payment">
                    <h4 className="sub-heading">
                      Você ainda não cadastrou nenhuma forma de pagamento.
                    </h4>
                    <a> Cadastrar agora </a> 
                  </span>
                } */}

                <span id="entrega"/>
                <span className="title-action">
                  <h3> Endereço de Entrega </h3>
                  <a title="Clique para editar" href="/editar/endereco"> <FontAwesomeIcon icon={faEdit}/> </a>
                </span>
                {
                (this.state.pagamento) ?
                  <article className="dados-da-conta">
                    <div className="dados-container">
                      <p> CEP: </p>
                      <p> { this.state.customer.cep } </p>
                    </div>
                    <div className="dados-container">
                      <p> Rua: </p>
                      <p> { this.state.customer.rua } </p>
                    </div>
                    <div className="dados-container">
                      <p> Número: </p>
                      <p> { this.state.customer.numero } </p>
                    </div>
                    <div className="dados-container">
                      <p> Bairro: </p>
                      <p> { this.state.customer.bairro } </p>
                    </div>
                    <div className="dados-container">
                      <p> Cidade: </p>
                      <p> { this.state.customer.cidade } </p>
                    </div>
                    <div className="dados-container">
                      <p> Estado: </p>
                      <p> { this.state.customer.estado } </p>
                    </div>
                    <div className="dados-container">
                      <p> Complemento: </p>
                      <p> { this.state.customer.complemento || "-" } </p>
                    </div>
                  </article>
                :
                  <span className="register-payment">
                    <h4 className="sub-heading">
                      Você ainda não cadastrou nenhum endereço de entrega.
                    </h4>
                    <a href="/editar/endereco"> Cadastrar agora </a> 
                  </span>
                }

                  {/* <span id="meus-favoritos"/>
                  <h3> Favoritos </h3>

                  <a className="mb-4 btn-link-action"> Remover Todos </a>

                <article className="favoritos">

                  <Favorito src={produto} produto="Carne" valor="29,99"/>
                  <Favorito src={produto} produto="Carne" valor="29,99"/>
                  <Favorito src={produto} produto="Carne" valor="29,99"/>
                  <Favorito src={produto} produto="Carne" valor="29,99"/>
                  <Favorito src={produto} produto="Carne" valor="29,99"/>
                  <Favorito src={produto} produto="Carne" valor="29,99"/>
                  <Favorito src={produto} produto="Carne" valor="29,99"/>

                </article> */}
              </>
              }
              
              {/* <a className="logout-anchor" onClick={this.handleLogout.bind(this)}>
                Sair 
              </a> */}
            </Col>
          </Row>
        </section>

        <Footer/>
      </>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  user: state.user.data,
  cart: state.cart.data,
  param: state.param.data,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({...UserActions, ...ParamActions, ...CartActions}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MeuCadastro);